import { cn } from "@tameeni/shared-logic";
import TameeniLoader from "./tameeni-loader";

const TameeniLoaderOverlay = ({ transparent = true }) => {
  return (
    <div
      className={cn(
        "flex-center fixed inset-0 z-50 flex h-screen w-screen items-center justify-center",
        transparent ? "bg-base-black/70" : "bg-base-white",
      )}
    >
      <TameeniLoader />
    </div>
  );
};

export default TameeniLoaderOverlay;
